import * as actionTypes from './actionType';

export const dispatchIsUserDefaultMsgSet = (data) => ({
    type: actionTypes.IS_SER_DEFAULT_MSG_SET,
    isUserDefaultSet: data,
  });